
export function hexToRGB(hex: string) {

    if(hex.length===4)//convert #fff to #ffffff
      hex = hex+hex.slice(1,4);
  
    var r = parseInt(hex.slice(1, 3), 16),
      g = parseInt(hex.slice(3, 5), 16),
      b = parseInt(hex.slice(5, 7), 16),
      a = hex.length > 7 ? parseInt(hex.slice(7, 9), 16) / 255 : 1;
  
    return { r: r, g: g, b: b, a: a };
  }
  
  export function rgbToHex(r: number, g: number, b: number, a: number) {
    let hex = "#" + byteToHex(r) + byteToHex(g) + byteToHex(b);
  
    if (a < 1) {
      hex += byteToHex(Math.round(a * 255));
    }
  
    return hex;
  }

  
function byteToHex(b: number) {
    let str = b.toString(16);
    if (str.length == 1) str = "0" + str;
  
    return str.substring(0, 2);
  }
  


export function ColorRelativeLumananceFromHex(hex:string):number{
  let rgb = hexToRGB(hex);

  let r = rgb.r/255.0;
  let g = rgb.g/255.0;
  let b = rgb.b/255.0;


  // Calculate the normalized RGB values using the sRGB adjustment
  const R = r <= 0.03928 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4);
  const G = g <= 0.03928 ? g / 12.92 : Math.pow((g + 0.055) / 1.055, 2.4);
  const B = b <= 0.03928 ? b / 12.92 : Math.pow((b + 0.055) / 1.055, 2.4);

  // Calculate relative luminance using the sRGB color space formula
  const L = 0.2126 * R + 0.7152 * G + 0.0722 * B;

  return L;



}

// (4.5:1 for normal text, 3:1 for large text).
export function ColorContrastRatio(hexA:string,hexB:string){

  let l1 = ColorRelativeLumananceFromHex(hexA);
  let l2 = ColorRelativeLumananceFromHex(hexB);
  return (Math.max(l1,l2)+0.05)/(Math.min(l1,l2)+0.05);
}